import React, { useEffect, useRef, useState } from 'react'
import styles from './blog.module.scss'
import moment from 'moment'
import { PAGE_SIZE } from 'consts'
import { POSITION_TABLE, ROUTES } from 'consts'
import { Link, useHistory } from 'react-router-dom'

//components
import FilterDate from 'components/filter-date'

// icons
import { DeleteOutlined, PlusCircleOutlined, SearchOutlined } from '@ant-design/icons'

//antd
import { Button, Input, message, Table, Popconfirm, Row, Col, notification } from 'antd'

// apis
import { deleteBlog, getBlogs } from 'apis/blog'

export default function Blog() {
  const history = useHistory()

  const [loadingTable, setLoadingTable] = useState(false)
  const [blogs, setBlogs] = useState([])
  const [countPage, setCountPage] = useState('')
  const [paramsFilter, setParamsFilter] = useState({ page: 1, page_size: PAGE_SIZE })
  const [valueSearch, setValueSearch] = useState('')
  const typingTimeoutRef = useRef(null)

  const columns = [
    {
      title: 'STT',
      width: 80,
      align: 'center',
      render: (text, record, index) => index + 1,
    },
    {
      title: 'Tiêu đề',
      dataIndex: 'title',
      align: 'center',
      render: (text, record) => (
        <Link to={{ pathname: ROUTES.BLOG_UPDATE, state: record }}>{text}</Link>
      ),
    },
    {
      title: 'Phụ đề',
      dataIndex: 'subtitle',
      align: 'center',
    },
    {
      title: 'Chi nhánh',
      align: 'center',
      render: (text, record) => record.branch_info && record.branch_info.name,
    },
    {
      title: 'Ngày tạo',
      dataIndex: 'create_date',
      align: 'center',
      render: (text) => moment(text).format('DD/MM/YYYY HH:mm'),
    },
    {
      title: 'Hành động',
      align: 'center',
      render: (text, record) => (
        <Popconfirm
          onConfirm={() => _deleteBlog(record.blog_id)}
          title="Bạn có muốn xóa bài viết này không?"
        >
          <Button type="primary" danger icon={<DeleteOutlined />} />
        </Popconfirm>
      ),
    },
  ]

  const _getBlogs = async () => {
    try {
      setLoadingTable(true)
      const res = await getBlogs(paramsFilter)
      if (res.status === 200) {
        setBlogs(res.data.data)
        setCountPage(res.data.count)
      }
      setLoadingTable(false)
    } catch (err) {
      console.log(err)
    }
  }

  const _deleteBlog = async (id) => {
    try {
      const res = await deleteBlog([id])
      console.log(res)
      if (res.status === 200) {
        if (res.data.success) {
          notification.success({ message: 'Xóa bài viết thành công' })
          _getBlogs()
        } else notification.error(res.data.message || 'Xóa bài viết không thành công')
      } else notification.error({ message: res.data.message || 'Xóa bài viết không thành công' })
    } catch (err) {
      console.log(err)
    }
  }

  const _search = (e) => {
    setValueSearch(e.target.value)
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current)
    }
    typingTimeoutRef.current = setTimeout(async () => {
      const value = e.target.value
      if (value) paramsFilter.title = value
      else delete paramsFilter.title
      setParamsFilter({ ...paramsFilter, page: 1 })
    }, 650)
  }

  useEffect(() => {
    _getBlogs()
  }, [paramsFilter])

  return (
    <div className={`${styles['promotion_manager']} ${styles['card']}`}>
      <Row
        wrap={false}
        align="middle"
        justify="space-between"
        style={{ borderBottom: '1px solid rgb(236, 226, 226)', paddingBottom: '0.75rem' }}
      >
        <div style={{ fontWeight: '600', fontSize: '1.2rem' }}>Quản lý bài viết</div>

        <Button
          onClick={() => history.push(ROUTES.BLOG_CREATE)}
          size="large"
          icon={<PlusCircleOutlined />}
          type="primary"
        >
          Thêm bài viết
        </Button>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 10 }}>
        <Col xs={24} sm={24} md={12} lg={12} xl={8}>
          <Input
            prefix={<SearchOutlined />}
            placeholder="Tìm kiếm bài viết theo tiêu đề"
            allowClear
            className="search-filter-custom"
            onChange={_search}
            value={valueSearch}
            size="large"
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={6}>
          <FilterDate size="large" paramsFilter={paramsFilter} setParamsFilter={setParamsFilter} />
        </Col>
      </Row>
      <br />
      <Table
        rowKey="blog_id"
        size="small"
        loading={loadingTable}
        columns={columns}
        dataSource={blogs}
        pagination={{
          position: POSITION_TABLE,
          total: countPage,
          current: paramsFilter.page,
          pageSize: paramsFilter.page_size,
          onChange(page, pageSize) {
            setParamsFilter({
              ...paramsFilter,
              page: page,
              page_size: pageSize,
            })
          },
        }}
      />
    </div>
  )
}
